import React from "react";
import { formatNumberIntl } from "../../../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import MeasureItem from "../common/MeasureItem";
import SpecItem from "../common/SpecItem";
import type { SpecsSectionPropsType } from "../Specifications";
import Text from "../../../../../../../shared-components/lexus/styles/atoms/Text";
import List from "../../../../styles/atoms/List";
import { SrOnly } from "../../../../../../../shared-components/lexus/styles/utils/Accessibility.styles";
import { useUscLabel } from "../../../../../../utils/labels";
import VisualCarDimensionFront from "../../../../assets/visuals/car-dimension-front.svg";
import VisualCarDimensionSide from "../../../../assets/visuals/car-dimension-side.svg";
import * as Styles from "./SectionDimensions.styles";

const SectionDimensions = ({ product, cultureName, title, specs }: SpecsSectionPropsType): JSX.Element => {
    const [widthLabel, heightLabel, lenghtLabel] = useUscLabel([
        "uscA11yInputWidth",
        "uscA11yInputHeight",
        "uscA11yInputLength",
    ]);
    return (
        <div>
            <Text tag="h4" variant="h6">
                {title}
            </Text>
            <List variant="specs" tag="dl">
                {product.doors && specs.doors && <SpecItem title={specs.doors.title} value={product.doors} />}

                {product.seats && specs.seats && <SpecItem title={specs.seats.title} value={product.seats} />}

                {product.bootCapacity && product.bootCapacity.value > 0 && specs.bootCapacity && (
                    <MeasureItem
                        title={specs.bootCapacity.title}
                        measure={product.bootCapacity}
                        cultureName={cultureName}
                    />
                )}
            </List>

            {/* Car dimensions */}
            {/* We could add a spec specifically for this, e.g carDimensions or just always have this included (so not configurable) */}
            {(!!product.length || !!product.height || !!product.width) && (
                <Styles.Wrapper>
                    <Styles.FrontView>
                        <VisualCarDimensionFront role="img" aria-labelledby="car-front-view" />
                        <figcaption id="car-front-view">
                            {product.length && product.length.value > 0 && (
                                <>
                                    <SrOnly>{lenghtLabel}</SrOnly>
                                    <Text tag="span" variant="paragraph-body-book">
                                        {formatNumberIntl(product.length.value, cultureName)}{" "}
                                        {product.length.unit.description}
                                    </Text>
                                </>
                            )}
                            {product.height && product.height.value > 0 && (
                                <Styles.CarHeight>
                                    <SrOnly>{heightLabel}</SrOnly>
                                    <Text tag="span" variant="paragraph-body-book">
                                        {formatNumberIntl(product.height.value, cultureName)}{" "}
                                        {product.height.unit.description}
                                    </Text>
                                </Styles.CarHeight>
                            )}
                        </figcaption>
                    </Styles.FrontView>
                    <Styles.SideView>
                        <VisualCarDimensionSide role="img" aria-labelledby="car-side-view" />
                        <figcaption id="car-side-view">
                            {product.width && product.width.value > 0 && (
                                <>
                                    <SrOnly>{widthLabel}</SrOnly>
                                    <Text tag="span" variant="paragraph-body-book">
                                        {formatNumberIntl(product.width.value, cultureName)}{" "}
                                        {product.width.unit.description}
                                    </Text>
                                </>
                            )}
                        </figcaption>
                    </Styles.SideView>
                </Styles.Wrapper>
            )}
        </div>
    );
};

export default SectionDimensions;
